const PRODUCT_SLUG_INTEREST_LABELS: Record<string, string> = {
  'comic-ai-video-motion-capture': 'Comic',
  'api-access': 'our API',
  'swing-motion-generation': 'Swing',
  'motion-editor': 'Motion Editor',
  mascot: 'Mascot',
  'character-generation': 'Character Generator',
  'motion-library': 'Motion Library',
  cartographer: 'Cartographer',
};

export function formatPluginInterestLabel(pluginName: string): string {
  return `the ${pluginName} plugin`;
}

export function formatNotifyMeInterestSubject(
  excitedAbout?: string,
  interestLabel?: string,
): string | null {
  const explicitLabel = interestLabel?.trim();
  if (explicitLabel) {
    return explicitLabel;
  }

  const trimmed = excitedAbout?.trim();
  if (!trimmed) {
    return null;
  }

  const workflowPrefix = 'Workflow: ';
  if (trimmed.startsWith(workflowPrefix)) {
    const title = trimmed.slice(workflowPrefix.length);
    return `the "${title}" workflow`;
  }

  const productLabel = PRODUCT_SLUG_INTEREST_LABELS[trimmed];
  if (productLabel) {
    return productLabel;
  }

  if (/\bplugin$/i.test(trimmed)) {
    const name = trimmed.replace(/\s*plugin$/i, '');
    return `the ${name} plugin`;
  }

  if (/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(trimmed)) {
    return trimmed
      .split('-')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  if (/^(the|our|a|an)\s/i.test(trimmed)) {
    return trimmed;
  }

  return trimmed;
}

export function getNotifyMeInterestLead(
  excitedAbout?: string,
  interestLabel?: string,
): string {
  const subject = formatNotifyMeInterestSubject(excitedAbout, interestLabel);

  if (subject) {
    return `Thank you for your interest in ${subject}.`;
  }

  return 'Thanks for your interest.';
}
